/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
	import like_component from "../components/like-component.vue";
	import property_features_component from "../components/property-features-component.vue";
    // import Popper from 'vue3-popper';
    const __vue_script__ ={
        components: {
            like_component,
            property_features_component,
        },
		name:'property_component_horizontal',
        props: {
            property_json: {
                type: String,
            },
            property_data: {
                type: Object,
            },
            can_observe: {
                type: Boolean,
                default: false,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: true,
                pre_loaded: false,
                visible: false,
                ad_type_color: '#0000ff',
                ad_type_color_wt: '#0000ff',
                property_type_icon: '#0000ff',
                property: null
			};
		},
        mounted(){
            if(this.property_json != undefined)
                this.property = JSON.parse(this.property_json);
            else
                this.property = this.property_data;
            // this.property['creation'] = new Date(this.property['creation'])
            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+"aa";
            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
            if(this.can_observe){
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.load_property_card();
                            this.visible = true;
                        } else {
                            this.visible = false;
                        }
                    });
                }, {
                    threshold: 0.2 // Trigger when 20% of the element is visible
                });
                el = document.getElementById(this.property['name'])
                observer.observe(el);
            }else{
                this.load_property_card();
                this.visible = true;
            }
        },
		methods: {
            load_property_card: async function(){
                if(this.pre_loaded || this.property["name"] == undefined)
                    return;
                let params = {
                    property_name: this.property["name"]
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_property_card",
                        type: "GET",
                        data: params //for GET request
                    });
                    this.property = res.message;
                    this.property.creation = new Date(this.property.creation)
                    this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
                    this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
                    this.main_building = true;
                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed");
                    console.log(e);
                    this.exceptions = helper.showException(e);
                    return;
                }

                this.pre_loaded = true
                this.is_loading = false
                // global.emitter.on("refresh-property-component", args => {
                //     if(this.property_json != undefined)
                //         this.property = JSON.parse(this.property_json);
                //     else
                //         this.property = this.property_data;
                //     this.$forceUpdate();
                // });
            },
			check_enabled: function(field){
				if (this.property.property_type=="")
					return false;
				return this.enabled_fields.includes(field);
			},
            open_page: function(link,target="_BLANK"){
                window.open(link,target);
            }
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.property.property_type];
                global.property_constants.remove_field[this.property.ad_type].forEach(field => {
                    const index = fields.indexOf(field);
                    if (index > -1) { // only splice array when item is found
                        fields.splice(index, 1); // 2nd parameter means remove one item only
                    }
                });
                if(this.is_child){
                    global.property_constants.remove_child_field.forEach(field => {
                        const index = fields.indexOf(field);
                        if (index > -1) { // only splice array when item is found
                            fields.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    });
                }
                return fields;
            }
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c("div", { staticClass: "card property-card" }, [
        _vm.visible
          ? _c("div", { staticClass: "row g-0" }, [
              _c(
                "a",
                {
                  staticClass: "col-sm-4",
                  staticStyle: {
                    "background-size": "cover",
                    "background-position": "center",
                    "min-height": "184px"
                  },
                  style: {
                    "background-image":
                      "url(/" +
                      encodeURIComponent(_vm.property.image.substr(1)) +
                      ")"
                  },
                  attrs: {
                    href: "/property/" + _vm.property["name"],
                    target: "_blank"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "top fw-bold text-black px-3",
                      class: _vm.frappe.lang_dir == "ltr" ? "left" : "right",
                      style: { "background-color": _vm.ad_type_color_wt }
                    },
                    [_vm._v(_vm._s(_vm.helper.t(_vm.property.ad_type)))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "card-header fw-bold text-primary p-1 d-flex justify-content-between",
                    attrs: {
                      href: "/property/" + _vm.property["name"],
                      target: "_blank",
                      role: "button"
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.helper.t("{0} for " + _vm.property.ad_type, [
                            _vm.helper.t(_vm.property.property_type)
                          ])
                        ) +
                        "\n                "
                    ),
                    _c("small", { staticClass: "fw-bold text-primary" }, [
                      _vm._v(_vm._s(_vm.property.name))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body p-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _vm.property["total_price"] != undefined &&
                        _vm.property["total_price"]
                          ? [
                              _c(
                                "small",
                                { staticClass: "fw-normal fw-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.helper.nFormatter(
                                        _vm.property["total_price"]
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    !_vm.is_loading
                      ? [
                          _c("property_features_component", {
                            attrs: { property_data: _vm.property }
                          }),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "p-0 m-0",
                              staticStyle: { "line-height": "2rem" }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.property.location_address) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", { staticClass: "fw-normal" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.helper.t("Creation:")))
                            ]),
                            _vm._v(" "),
                            _c("span", { attrs: { dir: "ltr" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.property["creation"].getDate() +
                                    "-" +
                                    _vm.global.global_params.months[
                                      _vm.property["creation"].getMonth()
                                    ] +
                                    "-" +
                                    _vm.property["creation"].getFullYear()
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "fw-normal" }, [
                            _c("b", [_vm._v(_vm._s(_vm.helper.t("Updated:")))]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.helper.toMomentStringTranslation(
                                    _vm.property["modified"]
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "like card-footer user d-flex px-2 py-1" },
                  [
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/user-catalogue/" + _vm.property.uploader_id,
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.property.uploader_full_name))]
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.is_loading
                      ? [
                          !_vm.property.own
                            ? _c("div", { staticClass: "ms-2" }, [
                                _c("i", {
                                  staticClass: "fa-solid fa-flag",
                                  attrs: {
                                    role: "button",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#reportModal",
                                    "data-bs-property-name":
                                      _vm.property["name"]
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.property["view_count"]
                            ? _c("div", { staticClass: "ms-2" }, [
                                _c("i", { staticClass: "fa fa-solid fa-eye" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.property["view_count"]) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.frappe.session_user != "Guest"
                            ? _c("like_component", {
                                staticClass: "ms-2",
                                attrs: { property_data: _vm.property }
                              })
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1488b5ae_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.single-properties-item .properties-content p{\n    padding-left:0 !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/property-component-horizontal.vue"],"names":[],"mappings":";AAyMA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA;AACA;IACA,yBAAA;AACA","file":"property-component-horizontal.vue","sourcesContent":["<template>\r\n    <div v-if=\"property\" class=\"card property-card\">\r\n        <div v-if=\"visible\" class=\"row g-0\">\r\n            <a class=\"col-sm-4\" style=\"background-size: cover; background-position: center; min-height:184px;\" :style=\"{ 'background-image': `url(/${encodeURIComponent(property.image.substr(1))})`}\"\r\n            :href=\"'/property/'+property['name']\"\r\n            target=\"_blank\">\r\n                <span class=\"top fw-bold text-black px-3\" :class=\"frappe.lang_dir=='ltr'?'left':'right'\" :style=\"{'background-color':ad_type_color_wt}\">{{ helper.t(property.ad_type) }}</span>\r\n            </a>\r\n            <div class=\"col-sm-8\">\r\n                <a class=\"card-header fw-bold text-primary p-1 d-flex justify-content-between\"\r\n                    :href=\"'/property/'+property['name']\"\r\n                    target=\"_blank\"\r\n                    role=\"button\">\r\n                    {{helper.t(\"{0} for \"+property.ad_type,[helper.t(property.property_type)])}}\r\n                    <small class=\"fw-bold text-primary\">{{ property.name }}</small>\r\n                </a>\r\n                <div class=\"card-body p-1\">\r\n                    <div class=\"d-flex justify-content-between\">\r\n                        <template v-if=\"property['total_price'] != undefined && property['total_price']\">\r\n                            <small class=\"fw-normal fw-bold\">{{ helper.nFormatter(property['total_price']) }}</small>\r\n                        </template>\r\n                    </div>\r\n                    <template v-if=\"!is_loading\">\r\n                        <property_features_component\r\n                            :property_data=\"property\"\r\n                        ></property_features_component>\r\n                        <small class=\"p-0 m-0\" style=\"line-height: 2rem;\">\r\n                            {{ property.location_address }}\r\n                        </small><br>\r\n                        <small class=\"fw-normal\">\r\n                            <b>{{ helper.t(\"Creation:\") }}</b> <span dir=\"ltr\">{{ property['creation'].getDate() +\"-\"+ global.global_params.months[property['creation'].getMonth()] +\"-\"+ property['creation'].getFullYear() }}</span>\r\n                        </small>\r\n                        <small class=\"fw-normal\">\r\n                            <b>{{ helper.t(\"Updated:\") }}</b> {{ helper.toMomentStringTranslation(property['modified']) }}\r\n                        </small>\r\n                    </template>\r\n                </div>\r\n                <div class=\"like card-footer user d-flex px-2 py-1\">\r\n                    <div class=\"flex-grow-1\">\r\n                        <a :href=\"'/user-catalogue/'+property.uploader_id\" target=\"_blank\">{{ property.uploader_full_name }}</a>\r\n                    </div>\r\n                    <template v-if=\"!is_loading\">\r\n                        <div v-if=\"!property.own\" class=\"ms-2\">\r\n                            <i class=\"fa-solid fa-flag\"\r\n                                role=\"button\"\r\n                                data-bs-toggle=\"modal\" data-bs-target=\"#reportModal\" :data-bs-property-name=\"property['name']\"\r\n                            ></i>\r\n                        </div>\r\n                        <div v-if=\"property['view_count']\" class=\"ms-2\">\r\n                            <i class=\"fa fa-solid fa-eye\"></i> {{ property['view_count'] }}\r\n                        </div>\r\n                        <like_component\r\n                            v-if=\"frappe.session_user!='Guest'\"\r\n                            class=\"ms-2\"\r\n                            :property_data=\"property\"\r\n                        ></like_component>\r\n                    </template>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    \r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n\timport like_component from \"../components/like-component.vue\";\r\n\timport property_features_component from \"../components/property-features-component.vue\";\r\n    // import Popper from 'vue3-popper';\r\n    export default{\r\n        components: {\r\n            like_component,\r\n            property_features_component,\r\n        },\r\n\t\tname:'property_component_horizontal',\r\n        props: {\r\n            property_json: {\r\n                type: String,\r\n            },\r\n            property_data: {\r\n                type: Object,\r\n            },\r\n            can_observe: {\r\n                type: Boolean,\r\n                default: false,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: true,\r\n                pre_loaded: false,\r\n                visible: false,\r\n                ad_type_color: '#0000ff',\r\n                ad_type_color_wt: '#0000ff',\r\n                property_type_icon: '#0000ff',\r\n                property: null\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            if(this.property_json != undefined)\r\n                this.property = JSON.parse(this.property_json);\r\n            else\r\n                this.property = this.property_data;\r\n            // this.property['creation'] = new Date(this.property['creation'])\r\n            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];\r\n            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+\"aa\";\r\n            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];\r\n            if(this.can_observe){\r\n                const observer = new IntersectionObserver((entries) => {\r\n                    entries.forEach(entry => {\r\n                        if (entry.isIntersecting) {\r\n                            this.load_property_card();\r\n                            this.visible = true;\r\n                        } else {\r\n                            this.visible = false;\r\n                        }\r\n                    });\r\n                }, {\r\n                    threshold: 0.2 // Trigger when 20% of the element is visible\r\n                });\r\n                el = document.getElementById(this.property['name'])\r\n                observer.observe(el);\r\n            }else{\r\n                this.load_property_card();\r\n                this.visible = true;\r\n            }\r\n        },\r\n\t\tmethods: {\r\n            load_property_card: async function(){\r\n                if(this.pre_loaded || this.property[\"name\"] == undefined)\r\n                    return;\r\n                let params = {\r\n                    property_name: this.property[\"name\"]\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.get_property_card\",\r\n                        type: \"GET\",\r\n                        data: params //for GET request\r\n                    });\r\n                    this.property = res.message;\r\n                    this.property.creation = new Date(this.property.creation)\r\n                    this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];\r\n                    this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];\r\n                    this.main_building = true;\r\n                    this.$forceUpdate();\r\n                } catch (e) {\r\n                    console.log(\"failed\");\r\n                    console.log(e);\r\n                    this.exceptions = helper.showException(e);\r\n                    return;\r\n                }\r\n\r\n                this.pre_loaded = true\r\n                this.is_loading = false\r\n                // global.emitter.on(\"refresh-property-component\", args => {\r\n                //     if(this.property_json != undefined)\r\n                //         this.property = JSON.parse(this.property_json);\r\n                //     else\r\n                //         this.property = this.property_data;\r\n                //     this.$forceUpdate();\r\n                // });\r\n            },\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (this.property.property_type==\"\")\r\n\t\t\t\t\treturn false;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n            open_page: function(link,target=\"_BLANK\"){\r\n                window.open(link,target);\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.property.property_type];\r\n                global.property_constants.remove_field[this.property.ad_type].forEach(field => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) { // only splice array when item is found\r\n                        fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                    }\r\n                });\r\n                if(this.is_child){\r\n                    global.property_constants.remove_child_field.forEach(field => {\r\n                        const index = fields.indexOf(field);\r\n                        if (index > -1) { // only splice array when item is found\r\n                            fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                        }\r\n                    });\r\n                }\r\n                return fields;\r\n            }\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n    .single-properties-item .properties-content p{\r\n        padding-left:0 !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/property-component-horizontal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__